import { $api } from "@/lib/api-client";

export interface StatementVoteBudget {
  freeTotal: bigint;
  freeAvailable: bigint;
  stakedTotal: bigint;
  stakedAvailable: bigint;
  isLoading: boolean;
  isError: boolean;
}

const toBig = (v: string | undefined): bigint => {
  try {
    return v ? BigInt(v) : 0n;
  } catch {
    return 0n;
  }
};

export const useStatementVoteBudget = (
  id: string,
  enabled: boolean,
): StatementVoteBudget => {
  const q = $api.useQuery(
    "get",
    "/statements/{id}/votes/budget",
    { params: { path: { id } } },
    { enabled },
  );
  // Global response wrapper nests under .data.data (same as votes/mine unwrap).
  const d = (q.data as { data?: Record<string, string> } | undefined)?.data;
  return {
    freeTotal: toBig(d?.freeTotal),
    freeAvailable: toBig(d?.freeAvailable),
    stakedTotal: toBig(d?.stakedTotal),
    stakedAvailable: toBig(d?.stakedAvailable),
    isLoading: q.isLoading,
    isError: q.isError,
  };
};
